module.exports = __webpack_public_path__ + "img/story021.4cdde5eb.webp";